import { useEffect, useState } from 'react';
import { handleError } from '../helpers/network';

export const useApiQuery = (action, options) => {
    const [state, setState] = useState({
        isLoading: true,
        data: null,
        error: null,
        exception: null
    });

    const hasData = !state.isLoading && state.data;

    useEffect(() => {
        setState((current) => ({
            ...current,
            isLoading: true
        }));

        action(options)
            .then((resp) => {
                if (resp.success) {
                    setState({
                        isLoading: false,
                        data: resp.data,
                        error: null,
                        exception: null
                    });
                } else {
                    setState({
                        isLoading: false,
                        error: resp.message,
                        data: null
                    });
                }
                if (resp.exception) {
                    setState((current) => ({
                        ...current,
                        exception: resp.exception
                    }));
                }
            })
            .catch((err) => {
                const error = handleError(err);
                setState({
                    data: null,
                    isLoading: false,
                    error: error.message,
                    exception: error.exception
                });
            });
    }, [action, options]);

    return {
        ...state,
        hasData
    };
};
